import {Box, CircularProgress, IconButton, Tooltip, Typography} from '@mui/material'
import {AttachFile, Download, Visibility} from '@mui/icons-material'
import {useState} from 'react'
import {useFileDownload} from '../../../logic'
import {getPreviewKind} from '../../../utils'
import {DocumentPreviewDialog} from '../../shared/documentPreview/DocumentPreviewDialog'

export function MessageAttachment({ documentFileName, documentDeleted, companyIdOrderIdHash, isOurs }: {
  documentFileName: string;
  documentDeleted?: boolean;
  companyIdOrderIdHash: string;
  isOurs: boolean;
}) {
  const downloadFile = {
    CompanyIdOrderIdHash: companyIdOrderIdHash,
    FileName: documentFileName,
    Type: 'reply' as const,
    DocumentFileName: documentFileName,
  }
  const { triggerDownload, isDownloading } = useFileDownload(downloadFile)
  const previewKind = getPreviewKind(documentFileName)
  const [isPreviewOpen, setIsPreviewOpen] = useState(false)

  function onClick() {
    triggerDownload()
  }

  if (documentDeleted) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          width: '100%',
          mt: 1,
          borderRadius: '8px',
          px: 1.25,
          py: 0.75,
          bgcolor: isOurs ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.05)',
          color: 'inherit',
          opacity: 0.5,
        }}
      >
        <AttachFile fontSize="small" sx={{ flexShrink: 0 }}/>
        <Typography variant="body2" sx={{ wordBreak: 'break-word', flex: 1, color: 'inherit' }}>
          {documentFileName || 'Attachment'} (deleted)
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        disabled={isDownloading}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          flex: 1,
          minWidth: 0,
          border: 'none',
          borderRadius: '8px',
          px: 1.25,
          py: 0.75,
          cursor: isDownloading ? 'default' : 'pointer',
          font: 'inherit',
          textAlign: 'left',
          bgcolor: isOurs ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.05)',
          color: 'inherit',
        }}
      >
        <AttachFile fontSize="small" sx={{ flexShrink: 0 }}/>
        <Typography variant="body2" sx={{ wordBreak: 'break-word', flex: 1, color: 'inherit' }}>
          {documentFileName || 'Attachment'}
        </Typography>
        {isDownloading ? <CircularProgress size={16} color="inherit"/> : <Download fontSize="small" sx={{ flexShrink: 0 }}/>}
      </Box>
      {previewKind && (
        <Tooltip title="Preview">
          <IconButton
            size="small"
            color="inherit"
            aria-label={`Preview ${documentFileName || 'attachment'}`}
            onClick={() => setIsPreviewOpen(true)}
          >
            <Visibility fontSize="small"/>
          </IconButton>
        </Tooltip>
      )}
      {previewKind && isPreviewOpen && (
        <DocumentPreviewDialog
          open
          onClose={() => setIsPreviewOpen(false)}
          title={documentFileName || 'Attachment'}
          kind={previewKind}
          file={downloadFile}
        />
      )}
    </Box>
  )
}
